import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import FlexRow from '../../../../molecules/FlexRow'
import DatasourceGroup from './DatasourceGroup'

function DatasourceLayout ({ items }) {
  const groupedItems = useMemo(() => {
    const normalizeBoolean = (value) => {
      if (typeof value === 'number') {
        return value === 1
      }
      return Boolean(value)
    }

    const normalizedItems = (items || []).map(item => ({
      ...item,
      isSystem: normalizeBoolean(item.isSystem),
      isInternal: normalizeBoolean(item.isInternal),
      isAiEnabled: normalizeBoolean(item.isAiEnabled),
      isAlwaysAvailable: normalizeBoolean(item.isAlwaysAvailable),
      isDeprecated: normalizeBoolean(item.isDeprecated)
    }))

    const grouped = normalizedItems.reduce((acc, item) => {
      if (!(item.namespace.code in acc)) {
        acc[item.namespace.code] = []
      }
      acc[item.namespace.code].push(item)

      return acc
    }, {})

    return Object.entries(grouped).map(([code, items]) => ({
      code,
      name: items.at(0).namespace.displayName,
      items
    }))
  }, [items])

  return (
    <FlexRow>
      {groupedItems.map(group => (
        <DatasourceGroup key={group.code} groupName={group.name} groupItems={group.items} />
      ))}
    </FlexRow>
  )
}

DatasourceLayout.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    catalogDatasourceId: PropTypes.number,
    code: PropTypes.string,
    displayName: PropTypes.string,
    imageUrl: PropTypes.string,
    namespace: PropTypes.shape({
      displayName: PropTypes.string
    })
  }))
}

export default DatasourceLayout
